import React from 'react';
import { Button, Typography } from '@kiiwi/ui';
import { useTranslation } from '@/src/i18n';
import { analyticsEvent } from '@/src/analytic_tag_manager';

const SectorCard = () => {
  const { t } = useTranslation();
  const handleClick = () => {
    analyticsEvent({
      category: 'TLCssRDV',
      action: 'TLCClicCardSecteur',
    });
    window.open(
      'https://maiia-guide.zendesk.com/hc/fr/articles/4408409122706-Tarifs-et-remboursements-de-la-t%C3%A9l%C3%A9consultation',
      '_blank',
    );
  };

  return (
    <div className="full-w relative overflow-hidden rounded-lg bg-brand-primary-enabled p-4">
      <Typography className="relative z-10 text-lg font-semibold text-neutral-inversed sm:max-w-[75%]">
        {t('tlc_sector_card_title')}
      </Typography>
      <Typography
        variant="body-2"
        className="hidden max-w-[75%] text-neutral-inversed sm:block"
      >
        {t('tlc_sector_card_text')}
      </Typography>
      <Button
        variant="secondary-inverse"
        className="mt-3"
        onClick={handleClick}
      >
        {t('learn_more')}
      </Button>
      <img
        src="/static/images/tlc-sector-banner.svg"
        alt=""
        className="absolute -bottom-3 -right-3 w-[130px] xs:w-[150px] sm:w-auto"
      />
    </div>
  );
};

export default SectorCard;
